import { Languages } from "src/api/types";
import { LANGUAGE, PRODUCT, STATUS } from "src/constants/searchParams";

export type FilterType = {
  name: string;
  placeholder: string;
};

export const filters: FilterType[] = [
  {
    name: STATUS,
    placeholder: "Status",
  },
  {
    name: PRODUCT,
    placeholder: "Product",
  },
  {
    name: LANGUAGE,
    placeholder: "Language",
  },
];

export const statuses = ["active", "inactive"];

export const languages: Languages[] = ["en", "es", "pt"];
